module.exports = __webpack_public_path__ + "img/base_activites_port.2088590f.svg";